//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import useMessageSnoozeAction from "./useMessageSnoozeAction";
import useMessageForwardAction from "./useMessageForwardAction";

function useQuickActions(supportIssue: WintSuperkollAPIModel.SupportIssue, reloadHandler: () => void) {
  const snoozeAction = useMessageSnoozeAction(supportIssue.id, reloadHandler);
  const forwardAction = useMessageForwardAction(
    supportIssue.id,
    reloadHandler,
    supportIssue.isConfidential,
    supportIssue.isAgencyCase
  );

  const quickActions: MoreActionMenuItem[] = [];
  if (supportIssue.state === WintSuperkollAPIModel.SupportIssueState.AtCustomer) {
    quickActions.push(snoozeAction);
  }
  // Same rule as the more-menu (moreActions.tsx): on a stamped case the server's canForward is the
  // whole answer, and the action goes through AgencyForward. Without this the header button showed
  // for the customer and posted SendTo, which Core refuses for a stamped case (403).
  if (!supportIssue.isAgencyCase || supportIssue.canForward) {
    quickActions.push(forwardAction);
  }

  return quickActions;
}

export default useQuickActions;
